import ReactImageUploading from "react-images-uploading";
import {ImageListType} from "react-images-uploading/dist/typings";
import {useState} from "react";
import {useApp} from "../app.context";
import {scaleImage} from "../utils/file.utils";

function UploadButton(props: { id: string }) {
    const {uploadFile} = useApp();
    const [loading, setLoading] = useState(false);
    const [images, setImages] = useState<ImageListType>([]);

    async function onChange(value: ImageListType) {
        if (loading) return;
        setImages(value as never[]);

        const file = value[0]?.file;
        if (!file) return;

        scaleImage(file, 256, async newFile => {
            setLoading(true);
            await uploadFile(props.id, newFile);
            setImages([]);
            setLoading(false);
        });
    }

    return (
        <ReactImageUploading value={images} onChange={onChange} maxNumber={1}>
            {({onImageUpload}) => (
                <button onClick={onImageUpload} disabled={loading}
                        title={'Replace image'}>
                    <span className={loading ? 'fa-solid fa-spinner' : 'fa-solid fa-file-import'}/>
                </button>
            )}
        </ReactImageUploading>
    );
}

export default UploadButton;
